import React from 'react';
import { SpaceAbout } from '@tribeplatform/react-components/Space';
import { useSlate } from '../../hooks/index.js';
export const SpaceAboutBlock = props => {
    const { context: { spaceId }, } = useSlate();
    return React.createElement(SpaceAbout, Object.assign({}, Object.assign({ spaceId }, props)));
};
//# sourceMappingURL=Block.js.map